import { reduxType } from "../../interfaces/reducerType"
const defaultState: number = 0;
function reducer(state = defaultState, { type, payload }: reduxType) {
    switch (type) {
        case "setPaginationNumber":
            return payload
        default:
            return state;
    }
}
export default reducer;